import { render, staticRenderFns } from "./prizeWheels.vue?vue&type=template&id=d7ac2c16&"
import script from "./prizeWheels.vue?vue&type=script&lang=js&"
export * from "./prizeWheels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports